"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ApptPurpose;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _framerMotion = require("framer-motion");
var _propTypes = require("prop-types");
var _constants = require("../../lib/constants");
var _ApptPurposeSkeleton = _interopRequireDefault(require("./ApptPurposeSkeleton"));
var _FilteredApptPurposes = require("./FilteredApptPurposes");
var _UnfilteredApptPurposes = require("./UnfilteredApptPurposes");
const variants = {
  initial: direction => ({
    opacity: 0,
    x: direction === -1 ? '-20%' : '20%'
  }),
  enter: {
    // NOTE: x's value needs to be `percentage` or else it'll throw an error when testing
    x: '0%',
    opacity: 1
  },
  exit: direction => ({
    x: direction === -1 ? '30%' : '-30%',
    opacity: 0,
    transition: {
      duration: 0.1
    }
  })
};
function ApptPurpose(_ref) {
  let {
    apptPurposeTitle,
    patientRel,
    purposes,
    onSelect,
    selectedPurpose = {},
    virtualVisitConfig,
    isApptPurposeLoading,
    apptPurposeFilterProps: {
      minPurposesForFilter = 10,
      ...restApptPurposeFilterProps
    } = {}
  } = _ref;
  const animationDirection = patientRel === _constants.NEW_PATIENT ? 1 : -1;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "ApptPurpose"
  }, isApptPurposeLoading === true && /*#__PURE__*/_react.default.createElement(_ApptPurposeSkeleton.default, null), isApptPurposeLoading === false && /*#__PURE__*/_react.default.createElement(_framerMotion.AnimatePresence, {
    custom: animationDirection,
    exitBeforeEnter: true
  }, purposes.length > minPurposesForFilter ? /*#__PURE__*/_react.default.createElement(_FilteredApptPurposes.FilteredApptPurposes, (0, _extends2.default)({
    key: patientRel,
    purposes: purposes,
    custom: animationDirection,
    animKey: patientRel,
    variants: variants,
    initial: "initial",
    animate: "enter",
    exit: "exit",
    selectedPurpose: selectedPurpose,
    onSelect: onSelect,
    virtualVisitConfig: virtualVisitConfig,
    ariaDescribedBy: "appointment-purpose-header",
    legend: apptPurposeTitle
  }, restApptPurposeFilterProps)) : /*#__PURE__*/_react.default.createElement(_UnfilteredApptPurposes.UnfilteredApptPurposes, {
    key: patientRel,
    custom: animationDirection,
    animKey: patientRel,
    variants: variants,
    initial: "initial",
    animate: "enter",
    exit: "exit",
    selectedPurpose: selectedPurpose,
    onSelect: onSelect,
    virtualVisitConfig: virtualVisitConfig,
    purposes: purposes,
    legend: apptPurposeTitle,
    ariaDescribedBy: "appointment-purpose-header"
  })));
}
const propTypes = {
  patientRelTitle: _propTypes.node,
  apptPurposeTitle: _propTypes.node,
  patientRel: _propTypes.node,
  purposes: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    name: _propTypes.string,
    visit_method: _propTypes.string,
    highlightedName: _propTypes.string
  })).isRequired,
  onSelect: _propTypes.func.isRequired,
  selectedPurpose: (0, _propTypes.shape)({
    name: _propTypes.string,
    visit_method: _propTypes.string,
    highlightedName: _propTypes.string
  }),
  showNoBooking: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string, _propTypes.bool]),
  NoBookingBanner: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.element]),
  virtualVisitConfig: (0, _propTypes.shape)({
    phone: _propTypes.string,
    video: _propTypes.string,
    in_person: _propTypes.string
  }),
  /**
   * Expect truthy value to display shimmer loading state
   * by default it's false
   */
  isApptPurposeLoading: _propTypes.bool,
  /* Properties for the appointment purpose filter controls */
  apptPurposeFilterProps: (0, _propTypes.shape)({
    /* Specifies the minimum number of appointment purposes before the filter controls are displayed */
    minPurposesForFilter: _propTypes.number,
    /* Labels for rendering the filter controls */
    labels: (0, _propTypes.shape)({
      noResultsLabel: _propTypes.string,
      purposeSearchLabel: _propTypes.string,
      purposeSearchPlaceholderLabel: _propTypes.string,
      visitTypeAllLabel: _propTypes.string,
      visitTypeInPersonLabel: _propTypes.string,
      visitTypeVirtualLabel: _propTypes.string
    }),
    /* Function executed when the name filter changes */
    onNameFilterChange: _propTypes.func,
    /* Function executed when the visit type filter changes */
    onVisitTypeFilterChange: _propTypes.func,
    /* Function executed when the filters are cleared */
    onClearFilters: _propTypes.func
  })
};
const defaultProps = {
  patientRelTitle: '',
  apptPurposeTitle: '',
  patientRel: '',
  selectedPurpose: {
    name: ''
  },
  virtualVisitConfig: {
    phone: 'Phone Visit',
    video: 'Video Visit',
    in_person: 'In Person'
  },
  isApptPurposeLoading: false
};
ApptPurpose.propTypes = propTypes;
ApptPurpose.defaultProps = defaultProps;
ApptPurpose.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ApptPurpose",
  "props": {
    "selectedPurpose": {
      "defaultValue": {
        "value": "{\n  name: ''\n}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "name": {
            "name": "string",
            "required": false
          },
          "visit_method": {
            "name": "string",
            "required": false
          },
          "highlightedName": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "apptPurposeFilterProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "minPurposesForFilter": {
            "name": "number",
            "required": false
          },
          "labels": {
            "name": "shape",
            "value": {
              "noResultsLabel": {
                "name": "string",
                "required": false
              },
              "purposeSearchLabel": {
                "name": "string",
                "required": false
              },
              "purposeSearchPlaceholderLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeAllLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeInPersonLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeVirtualLabel": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "onNameFilterChange": {
            "name": "func",
            "required": false
          },
          "onVisitTypeFilterChange": {
            "name": "func",
            "required": false
          },
          "onClearFilters": {
            "name": "func",
            "required": false
          }
        }
      },
      "required": false
    },
    "patientRelTitle": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "apptPurposeTitle": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "patientRel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "virtualVisitConfig": {
      "defaultValue": {
        "value": "{\n  phone: 'Phone Visit',\n  video: 'Video Visit',\n  in_person: 'In Person'\n}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "phone": {
            "name": "string",
            "required": false
          },
          "video": {
            "name": "string",
            "required": false
          },
          "in_person": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "isApptPurposeLoading": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Expect truthy value to display shimmer loading state\nby default it's false",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "purposes": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "name": {
              "name": "string",
              "required": false
            },
            "visit_method": {
              "name": "string",
              "required": false
            },
            "highlightedName": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": true
    },
    "onSelect": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "showNoBooking": {
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }, {
          "name": "bool"
        }]
      },
      "required": false
    },
    "NoBookingBanner": {
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "element"
        }]
      },
      "required": false
    }
  }
};